export default __webpack_public_path__ + "static/media/hht2_ep01_timeline_07.888f97ea.png";